export { ConsentOutcomeReducer } from './reducer';
export type { ConsentOutcomeState } from './types';
